module.exports = __webpack_public_path__ + "static/scale-model-of-jastro-park-in-bakersfield-california-6f75ed3949eca156ecb24ff3117ceac3.png";